<button
  type="button"
  [class]="'btn d-flex align-items-center ' + ((isConnectedWithExpertMode$ | async) ? 'btn-warning' : 'btn-danger')"
  (click)="onDisconnect()"
  [ngbTooltip]="tooltipText"
  placement="auto"
  container="body"
  [openDelay]="450"
>
  <i [class]="(isConnectedWithExpertMode$ | async) ? 'bi-plug' : 'bi-power'"></i>
</button>
